import { useContext, useEffect, useState } from "react"
import { AppContext } from "../../context/context"
import { baseUrl } from "../../config/delcare"
import UserFragment from "./user_fragment"

const UsersPage = () => {

    const {
        ww,
        setSideBarTitle,
        setPopupSidebarType,
        offCanvas,
        neonUser,
        setSelectedUser,
        reloadList, setReloadList,
        fetchDataV2
    } = useContext(AppContext)

    const [userList, setUserList] = useState([])
    const [displayUser, setDisplayUser] = useState([])
    const [search, setSearch] = useState("")
    const [sortMode, setSortMode] = useState(1)
    const [load, setLoad] = useState(false)

    const showCanvasHandler = (title, type, x) => {
        if (x) setSelectedUser(x)
        setSideBarTitle(title)
        setPopupSidebarType(type)
        offCanvas.show()
    }

    const getUsers = async () => {
        setLoad(true)
        setUserList([])
        setDisplayUser([])
        let query1 = "BRAND_GET_USER_ADMIN", params1 = [neonUser.agency?.agency_id || neonUser.user?.agency_id || neonUser.agency_id]
        let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
        setUserList(resp)
        setLoad(false)
    }

    const sortModeHandler = () => {
        if (sortMode == 1) {
            setSortMode(sortMode + 1)
            setUserList(userList.sort((a, b) => b.email.toLowerCase().localeCompare(a.email.toLowerCase())))
            return
        }
        if (sortMode >= 2) {
            setSortMode(1)
            setUserList(userList.sort((a, b) => a.email.toLowerCase().localeCompare(b.email.toLowerCase())))
            return
        }
    }

    useEffect(() => {
        if (neonUser.user_id) getUsers()
    }, [neonUser])

    useEffect(() => {
        if (reloadList) {
            setReloadList(false)
            getUsers()
        }
    }, [reloadList])

    useEffect(() => {
        if (userList.length > 0) setDisplayUser(userList)
    }, [userList])

    useEffect(() => {
        if (search) {
            setDisplayUser(userList.filter(x => x.email.toLowerCase().includes(search.toLowerCase())))
            return
        }
        else setDisplayUser(userList)
    }, [search])

    return (
        <UserFragment
            ww={ww}
            search={search}
            setSearch={setSearch}
            sortMode={sortMode}
            setReloadList={setReloadList}
            displayUser={displayUser}
            load={load}
            showCanvasHandler={showCanvasHandler}
            sortModeHandler={sortModeHandler}
            baseUrl={baseUrl}
        />
    )
}

export default UsersPage